<template>
	<div style="position: fixed; top: 52px; right: 30px; z-index: var(--ks-z-page-controls, 3);">
		<slot></slot>
		<template v-if="add">
      <k-btn color="primary" size="m" @click.stop="$emit('add')"><k-icon>add</k-icon></k-btn>
		</template>
	</div>
</template>
<script>
export default {
	props: {
		"add": {
			type: Boolean,
			default: true
		},
	}
}
</script>